import {RemoteGetSidebar} from 'data/usecases';
import {GetSidebar} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {BeneficiaryEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetSidebar = (): GetSidebar =>
	new RemoteGetSidebar(
		makeBFFApiUrl(BeneficiaryEndpoints.sidebar),
		makeAuthorizeHttpClientDecorator(),
	);
